import { Analytics } from '@/services/analytics';
import { AuthService } from '@/services/auth';
import { ClientService } from '@/services/client';

const analytics = new Analytics(AuthService, ClientService);

export { analytics };
